import React from 'react'
import { useWindowDimensions, ScrollView, View, Image } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useNavigation } from '@react-navigation/native'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'
import { useMediaQuery } from 'react-responsive'
import RenderHtml from 'react-native-render-html'
import YoutubePlayer from "react-native-youtube-iframe"

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'

const source1 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Programa de Certificação da Mulher Empresária</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>A Academia de Soluções Empreendedoras apresenta mais um programa aplicado e prático de capacitação e qualificação continuados.<br/>Após identificar necessidades, construiu, em parceria com a CEME – Câmara da Mulher Empresária da Fecomércio, um programa sob medida para mulheres sócias de empresas de micro e pequeno porte do comércio varejista e de serviços no Estado da Bahia.</p>
`
};

const source2 = {
  html: `
  <p style='text-align:left; font-size: smaller; line-height: 18px;'>O Programa de Certificação da Mulher Empresária tem por objetivo desenvolver uma mentalidade empreendedora que viabilize a transformação dos negócios liderados por mulheres, fomentando união, sororidade e cooperação entre elas.</p>
    `
}

const source3 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>O programa é composto de três etapas de capacitação: a Mulher, a Líder e o Negócio, abordando conteúdos sobre:</p>
<ul>
<li><span style='font-size: smaller;'>A Mulher: nesta etapa será abordado o autoconhecimento da participante visando a transformação da mentalidade empreendedora.</span></li>
<li><span style='font-size: smaller;'>Liderança: nesta etapa será abordado como formar uma liderança transformadora.</span></li>
<li><span style='font-size: smaller;'>Gestão: composto de dez módulos com conteúdo que apoiarão a melhoria da gestão da empresa.</span></li>
</ul>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Em cada módulo serão oferecidas mentorias individuais para cada empresa inscrita no programa, onde a empresária aplicará o conteúdo do curso no negócio de forma personalizada.<br/>Os cursos do programa são gratuitos e as mentorias individuais em cada módulo serão pagas de acordo com a adesão da empresa participante.<br/>Todos as alunas que concluírem o curso e tiverem mínimo de 75% de frequência em cada formação vão receber certificado Senac.<br/>A Câmara Estadual da Mulher Empresária irá emitir um Certificado pela Fecomércio para as empresárias que participarem em todos os módulos do Programa, de acordo com o perfil do estabelecimento da empresária (comércio ou serviços).</p>
`
};

const source4 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>12 meses, com carga horária total de 180 horas.<br/>Serão 12 módulos, que acontecerão durante uma semana por mês.<br/>As empresárias terão a opção de turmas no período matutino (de 9h às 12h) ou noturno (de 19h às 22h).
</p>
`
};

const source5 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Apenas para Associadas da Câmara Estadual da Mulher Empresária (CEME), do Estado da Bahia, proprietárias de pequenos negócios.</p>
`
}

const source6 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Todas as alunas que concluírem o curso e tiverem mínimo de 75% de frequência em cada formação vão receber certificado Senac.<br/>Adicionalmente, a Câmara da Mulher Empresária irá certificar aquelas empresárias que participarem em todos os cursos de 15h, de acordo com o perfil do estabelecimento da empresária (comércio ou serviços). 
</p>
`
}

const source7 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Mentorias e Mastermind* personalizados serão também oferecidos para aquelas empresárias que quiserem aperfeiçoar suas necessidades em qualificação.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px; font-weight: bold;'>*Consulte valores para as mentorias e masterminds.</p>
`
}

const source8 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Todos os cursos são gratuitos, sendo as Mentorias e Mastermind opcionais pagas.</p>
`
}

export default function MulherEmpresaria() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goForm = () => {
    navigation.navigate('FormRDMulher', {})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="Mulher Empresária" subtitle="Mulher Empresária" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
            <View style={[tailwind('mb-10'), {marginTop: isLargeScreen ? 110 : 150}]}>
                  <>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source1}
                  />
                </View>  
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>OBJETIVOS</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source2}
                  />
                </View>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>CONTEÚDO</Text>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source3}
                  />
                </View>  
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>DURAÇÃO</Text>
                <View style={tailwind('mx-5 mt-2')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source4}
                  />
                </View>  
                <View style={[tailwind('bg-black my-3'), { height: 1 }]} />
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goForm}><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE</Text></Button>
                </>
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
